<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/**
 * ============================================================
 * Smooth Scroll for Shopify Multi-language (Elle Theme, etc.)
 * Author: ChatGPT / OpenAI
 * Last updated: 2025-06
 * ============================================================
 */

document.addEventListener("DOMContentLoaded", function () {
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  anchorLinks.forEach(function (link) {
    let href = link.getAttribute("href");
    if (!href || !href.includes("#")) return;

    const url = new URL(href, window.location.origin);
    const hash = url.hash.replace("#", "");
    const isSamePath = url.pathname === window.location.pathname;

    if (isSamePath && hash) {
      // 替換 href 成純錨點形式（避免 reload）
      link.setAttribute("href", `#${hash}`);

      // 平滑滾動處理
      link.addEventListener("click", function (e) {
        const target = document.getElementById(hash);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth" });
          history.replaceState(null, null, `#${hash}`);
        }
      });
    }
  });
});







